<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Folder" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="ico-member-directory-copy" transform="translate(0, 3.52)" :fill="color" fill-rule="nonzero">
						<path d="M44,9.24 L44,32.34 C44,34.881 42.02,36.96 39.6,36.96 L4.4,36.96 C1.98,36.96 0,34.881 0,32.34 L0.022,4.62 C0.022,2.079 1.98,0 4.4,0 L16.0914286,0 C17.0547714,0 17.9760198,0.394820712 18.6403941,1.0924138 L20.9596059,3.5275862 C21.6239802,4.22517929 22.5452286,4.62 23.5085715,4.62 L39.6,4.62 L39.6,4.62 C42.02,4.62 44,6.699 44,9.24 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>